import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { IMigration, MigrationState } from '@shared';

@Component({
  selector: 'app-mapped-pro-table',
  templateUrl: './mapped-pro-table.component.html',
  styleUrls: ['./mapped-pro-table.component.scss'],
})
export class MappedProTableComponent implements OnInit {
  @Input() migrations: IMigration[] = [];
  @Input() isLoadingMigrations = false;
  @Output() navigateToMigration = new EventEmitter();

  ngOnInit() {}

  goTo(oneAccountId: string, proAccountId: string) {
    this.navigateToMigration.emit({ oneAccountId, proAccountId });
  }

  getMigrationStateClass(state: MigrationState) {
    switch (state) {
      case MigrationState.Failed:
        return 'danger';
      case MigrationState.Success:
        return 'success';
      case MigrationState.Pending:
        return 'warning';
      case MigrationState.Running:
        return 'primary';
      case MigrationState.Submitted:
        return 'primary';
      case MigrationState.Paused:
        return 'dark';
      default:
        return '';
    }
  }
}
